<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div class="product-list market-place-product-list">
      <div class="product-list-list"></div>
      <SessionContent></SessionContent>
      <b-card-group class="centered-block align-items-stretch d-flex flex-row flex-wrap" deck v-if="campaignProducts.length">
        <ProductTile v-for="campaignProduct in campaignProducts"
                     :key="'product-' + campaignProduct.id"
                     :product="campaignProduct">
        </ProductTile>
      </b-card-group>
      <div v-else>
        <div class="centered-block">
          <div class="step-title">No products found</div>
        </div>
      </div>
    </div>
    <b-row class="justify-content-center boxes select-item-btn customer-verify">
      <b-col v-if="session && session.can_undo" md="4" lg="3" cols="6">
        <b-button block @click="goBack()" variant="outline-primary" class="btn-back btn-outline-success">Back</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {InputType} from '../constants/index'

const ProductTile = () => import('./ProductTile')
const SessionContent = () => import('./SessionContent')
const Breadcrumbs = () => import('./Breadcrumbs')

export default {
  name: 'Products',
  components: {Breadcrumbs, SessionContent, ProductTile},
  props: {
    input: Object,
    title: String,
    subtitle: String,
    submit: {
      type: Function
    }
  },
  data: function() {
    return {
      campaignProducts: []
    }
  },
  computed: {
    ...mapState(['session'])
  },
  methods: {
    jumpAndGetProducts: function() {
      this.$store.commit('busy')
      this.$store.dispatch('jump', {step: 'product info'})
        .then(() => {
          console.log('Jumped to step products')
          this.getCampaignProducts()
        })
        .catch(err => {
          this.$store.commit('ready')
          this.$store.commit('critical_error', err)
        })
    },
    initProducts: function() {
      if (!this.session) { // If user directly lands on this page, then create session first
        this.$store.dispatch('start').then(_response => this.jumpAndGetProducts())
      } else if (this.session.step_type !== InputType.Product) {
        this.jumpAndGetProducts()
      } else {
        this.getCampaignProducts()
      }
    },
    getCampaignProducts: function() {
      axios.get('/campaign_products/info/').then(result => {
        console.log(result)
        this.campaignProducts = result.data.results
        this.$store.commit('ready')
      }, error => {
        console.log(error)
        this.$store.commit('critical_error', error)
        this.$store.commit('ready')
      })
    },
    done: function() {
      this.submit(this.input)
    },
    goBack: function() {
      this.$store.commit('busy')
      this.$store.dispatch('undo')
        .then(session => {
          this.$store.commit('clear_messages')
          this.$store.commit('increment_undo_count')
          this.$router.replace({name: 'session'})
        })
        .catch(err => {
          console.log(err)
          if (!err.response || err.response.status !== 422) {
            this.$store.commit('critical_error', err)
          }
        })
    }
  },
  created() {
    this.$store.commit('busy')
    this.initProducts()
  }
}
</script>

<style scoped>

</style>
